import { Box, Stack } from "@mui/material";

import { SpousalMaintenanceInputs } from "./components/SpousalMaintenanceInputs";
import { SpousalMaintenanceResult } from "./components/SpousalMaintenanceResult";
import { useSpousalMaintenanceCalculator } from "./hooks/useSpousalMaintenanceCalculator";

// Single-column layout used by the client portal: the questions, with the result underneath. The
// internal application composes the same inputs/result with its own two-column dialog layout.
export function SpousalMaintenanceCalculator() {
  const { formik, visibility, resultText } = useSpousalMaintenanceCalculator();

  return (
    <Stack spacing={1.5}>
      <SpousalMaintenanceInputs formik={formik} visibility={visibility} />
      <Box aria-live="polite">{resultText !== null && <SpousalMaintenanceResult result={resultText} />}</Box>
    </Stack>
  );
}
